import React from 'react'
import { createStackNavigator } from '@react-navigation/stack'
import ScreenHeader from '../../utility/ScreenHeader'
import DeleteAccount from '../../settings/delete-account'

const Stack = createStackNavigator()

const DeleteAccountHeader = (): React.ReactElement => (
  <ScreenHeader
    title="Delete Account"
    goBackEnabled
  />
)
DeleteAccountHeader.displayName = 'DeleteAccountHeader'

const DeleteAccountStack = (): React.ReactElement => (
  <Stack.Navigator
    id={undefined}
    screenOptions={{
      gestureEnabled: false,
      header: DeleteAccountHeader,
    }}
  >
    <Stack.Screen
      name="DeleteAccountHome"
      component={DeleteAccount}
    />
  </Stack.Navigator>
)

export default DeleteAccountStack
